import axiosInstance from "../config/axiosInstance";
import { ApiRoutes } from "../constants/ApiRoutes.ts";
import { QueryKeys } from "../constants/QueryKeys.ts";
import { useMutation, useQuery } from "@tanstack/react-query";
import { notification } from "antd";

const BidToolConfigServices = () => {
  const { FETCH_BIDTOOL_CONFIGURATIONS } = ApiRoutes;
  const { FETCH_BID_CONFIG_SETTINGS_KEY } = QueryKeys;

  const FetchSettingsBidConfig = (currentTab?: string) => {
    const getBidConfigInfo = async () => {
      const { data } = await axiosInstance.get(FETCH_BIDTOOL_CONFIGURATIONS);
      return data;
    };
    return useQuery({
      queryKey: [FETCH_BID_CONFIG_SETTINGS_KEY],
      queryFn: getBidConfigInfo,
      refetchOnWindowFocus: false,
      enabled: currentTab === undefined,
    });
  };
  const SubmitSettingsBidConfig = () => {
    const submitBidConfigInfo = async (payload) => {
      const { data } = await axiosInstance.put(
        FETCH_BIDTOOL_CONFIGURATIONS,
        payload,
      );
      return data;
    };
    return useMutation({
      mutationKey: [FETCH_BID_CONFIG_SETTINGS_KEY],
      mutationFn: submitBidConfigInfo,
      onSuccess: () => {
        notification.success({
          message: "BidTool updated successfully",
        });
      },
    });
  };

  return {
    FetchSettingsBidConfig,
    SubmitSettingsBidConfig,
  };
};
export default BidToolConfigServices;
